module.exports = __webpack_public_path__ + "static/img/nl.d4811c27.svg";